import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";
import MobileHelper from "../../../../../helpers/mobile";

export default function AllUserAreRegisteredByMarketer() {
  const [users, setUsers] = useState([]);
  const params = useParams();
  const userMarketerID = params.id;

  useEffect(() => {
    getAllUser();
  }, []);

  const getAllUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const users = await sendRequestGetUser(userMarketerID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!users) {
      return;
    }
    setUsers(users);
  };

  const sendRequestGetUser = async (userMarketerID) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/${userMarketerID}/get-all-user-are-registered-by-marketer`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateUsers = () => {
    return (
      <>
        <div className="text-left pb-2">
          <Link className="text-white" to="/user/marketer/all">
            <div className="btn btn-primary">
              <span>
                <span className="text-white">بازگشت</span>
              </span>
              <span className="pr-2">
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربری</td>
                <td>نام</td>
                <td>نام خانوادگی</td>
                <td>ایمیل</td>
                <td>شماره موبایل</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {users.map((item, index) => {
                return (
                  <tr>
                    <td>{helpersNumber.toPersianNum(index + 1)}</td>
                    <td>{helpersNumber.toPersianNum(item.id)}</td>
                    <td>{item.first_name}</td>
                    <td>{item.last_name}</td>
                    <td>{item.email}</td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(
                        MobileHelper.formatMobile(item.mobile)
                      )}
                    </td>
                    <td>
                      <span className="pl-2">
                        <Link
                          target="_blank"
                          className="btn btn-info"
                          to={`/user/show-info-user/${item.id} `}
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const generateDoseNotHaveUsers = () => {
    return (
      <div className="alert alert-info">
        بازاریاب هیچ کاربری را اضافه نکرده است.
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  نمایش کاربران ثبت نام شده توسط بازاریاب
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {users.length > 0 ? generateUsers() : generateDoseNotHaveUsers()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
